<template>
    <div class="app-header-hamburger-menu" v-if="menuOpen">
        <div class="fixed inset-0 z-10" @click="closeMenu()"></div>
        <div
            class="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white sm:max-w-sm sm:ring-1 sm:ring-gray-900/10"
        >
            <div class="flex items-center justify-between px-6 pt-6 pb-1">
                <div class="-m-1.5 p-1.5">
                    {{ $config.public.siteName }}
                </div>
                <button type="button" class="-m-2.5 rounded-md p-2.5 text-zinc-900" @click="closeMenu()">
                    <span class="sr-only">Close menu</span>
                    <svg
                        class="h-7 w-7"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        aria-hidden="true"
                    >
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
            <div class="mt-6 px-6 flow-root">
                <div class="-my-6 divide-y divide-gray-500/10" @click="closeMenu()">
                    <div class="space-y-2 py-6">
                        <nuxt-link :class="menuItemClasses" to="/"> Home </nuxt-link>
                        <a :class="menuItemClasses" :href="$config.public.courseUrl"> Course </a>
                        <nuxt-link :class="menuItemClasses" to="/videos"> Videos </nuxt-link>
                        <nuxt-link :class="menuItemClasses" to="/contact"> Contact </nuxt-link>
                    </div>
                    <div class="space-y-2 py-6">
                        <nuxt-link :class="menuItemClasses" to="/privates"> Private Lessons </nuxt-link>
                        <nuxt-link :class="menuItemClasses" to="/events"> Events Calendar </nuxt-link>
                        <nuxt-link :class="menuItemClasses" to="/shoes"> Dance Shoes </nuxt-link>
                        <nuxt-link :class="menuItemClasses" to="/chuck"> Chuck & Lauren </nuxt-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions} from 'pinia';

export default {
    name: 'AppHeaderHamburgerMenu',
    computed: {
        ...mapState(useHeaderStore, {
            menuOpen: 'menuOpen',
        }),
        menuItemClasses() {
            const cls = {};
            cls['-mx-3 block rounded-lg px-3 py-2 text-base font-bold leading-7 text-gray-900 hover:bg-gray-50'] = true;
            return cls;
        },
    },
    methods: {
        ...mapActions(useHeaderStore, {
            closeMenu: 'closeMenu',
        }),
    },
    watch: {
        $route() {
            this.closeMenu();
        },
    },
    beforeUnmount() {
        this.closeMenu();
    },
};
</script>
